/*
  useDailyWorkTime 内で定義していたが、
  定数インポートでpinia呼び出しエラーが発生してしまう場合があったため、
  それを回避するために単独ファイルに移動
*/
export const DEFAULT_DAILY_WORK_HOURS_PER_DAY = 8
export const DEFAULT_DAILY_WORK_MINUTES_PER_DAY = DEFAULT_DAILY_WORK_HOURS_PER_DAY * 60
export const DEFAULT_DAILY_WORK_SECONDS_PER_DAY = DEFAULT_DAILY_WORK_MINUTES_PER_DAY * 60
export const DEFAULT_DAILY_WORK_SECONDS_PER_MONTH = DEFAULT_DAILY_WORK_SECONDS_PER_DAY * 20
